<template>
  <section class="max-w-2xl mx-auto py-12 text-center">
    <div class="bg-white rounded-lg shadow p-8">
      <h1 class="text-3xl font-bold mb-4 text-green-600" v-if="status==='succeeded'">Merci ! Votre abonnement est activé.</h1>
      <h1 class="text-3xl font-bold mb-4 text-yellow-600" v-else-if="status==='processing'">Paiement en cours de traitement...</h1>
      <h1 class="text-3xl font-bold mb-4 text-red-600" v-else>Le paiement a échoué</h1>
      <p class="mb-4" v-if="status==='succeeded'">Vous recevrez un email de confirmation sous 5 minutes.</p>
      <p class="mb-4" v-if="status==='processing'">Nous vous informerons dès que le paiement sera validé.</p>
      <p class="mb-4" v-if="status==='requires_payment_method'">Merci de réessayer avec un autre moyen de paiement.</p>
      <router-link v-if="status==='succeeded'" to="/dashboard" class="bg-primary hover:bg-primary-dark text-white font-bold py-3 px-8 rounded shadow-lg transition inline-block mb-4">
        Accéder à Nailit
      </router-link>
      <div id="message" class="text-lg font-mono mt-4"></div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      status: null
    };
  },
  async mounted() {
    const stripe = window.Stripe('pk_test_51RRCT0CiTPUVpAF4zknQ9iAS8MZ84I3CYbobKVyDZF0RLi6Svmgs9zGCLDvBeEuRQgS98zWkKjABS7vUPCNPuczq00xCWbO1c2');
    const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');
    if (clientSecret) {
      const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
      this.status = paymentIntent.status;
    }
  }
};
</script>